import {useTranslation} from 'react-i18next'
import {CustomerIcon} from '../../../icons'

export const stepName = 'inviteCustomersToMarmalade'

export default (stepperData) => {
  const {t} = useTranslation('invitePayers')

  const icon = <CustomerIcon />
  const title = t('stepper.title')
  const subtitle = {default: t('stepper.tooltipParagraphOne')}

  const status = stepperData.payerTransitionCompleted
    ? 'completed'
    : 'incomplete'

  const prerequisiteStepsCompleted =
    stepperData.verificationStatus === 'verified' &&
    stepperData.supplierAgreementAccepted &&
    stepperData.payoutAccountConnected &&
    stepperData.connectedExpenseAccount

  const dashboardRegex = /^\/dashboard(\/.*)?$/
  if (dashboardRegex.test(window.location.pathname)) {
    const handleOnClick = () => {
      window.location.href = '/customers/transition_to_marmalade'
    }

    const isDisabled =
      !prerequisiteStepsCompleted || !stepperData.canTransitionPayersToMarmalade

    return {
      name: stepName,
      visible: stepperData.features.invitePayersToMarmalade,
      status,
      active: !isDisabled && status !== 'completed',
      icon,
      title,
      subtitle,
      action: {
        label: t('stepper.button'),
        onClick: handleOnClick,
      },
    }
  }

  return {
    name: stepName,
    visible: stepperData.features.invitePayersToMarmalade,
    status,
    active: false,
    icon,
    title,
    subtitle,
  }
}
